// const defaultConfigName = 'global-crf-prod';
// const defaultConfigName = 'global-dev';
// const defaultConfigName = 'global-desktop';
const defaultConfigName = 'global-online';
module.exports = defaultConfigName;
